const TRAILER_12 = {
  length: 13.6,
  width: 2.55,
  chassisY: 1.16,
  deckY: 1.32,
  boxTopY: 4,
  wheelRadius: 0.52,
  tyreWidth: 0.295,
  axleX: [-3.4, -4.71, -6.02],
  dualHalfTrack: 0.93,
  dualSpacing: 0.36,
  kingpinX: 5.1,
  landingLegX: 3,
  ribCount: 9,
  centreBeam: { x: -1.2, length: 10.5 },
  bogieLength: 3.5
};
const TRAILER_8 = {
  length: 10.4,
  width: 2.55,
  chassisY: 1.16,
  deckY: 1.32,
  boxTopY: 4,
  wheelRadius: 0.52,
  tyreWidth: 0.295,
  axleX: [-3.15, -4.46],
  dualHalfTrack: 0.93,
  dualSpacing: 0.36,
  kingpinX: 3.7,
  landingLegX: 2.2,
  ribCount: 7,
  centreBeam: { x: -0.9, length: 8 },
  bogieLength: 2.2
};
const TRAILER = TRAILER_12;
const trailerFrontX = (d) => d.length / 2;
const trailerTailX = (d) => -d.length / 2;
const TRAILER_FRONT_X = trailerFrontX(TRAILER_12);
const TRAILER_TAIL_X = trailerTailX(TRAILER_12);
export {
  TRAILER,
  TRAILER_12,
  TRAILER_8,
  TRAILER_FRONT_X,
  TRAILER_TAIL_X,
  trailerFrontX,
  trailerTailX
};
